// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"470":"31d6cfe0","842":"bfa07fe8"}[chunkId] + ".chunk.css";
};